import { render, staticRenderFns } from "./alarmInformation.vue?vue&type=template&id=5bfc8054&scoped=true"
import script from "./alarmInformation.vue?vue&type=script&lang=js"
export * from "./alarmInformation.vue?vue&type=script&lang=js"
import style0 from "./alarmInformation.vue?vue&type=style&index=0&id=5bfc8054&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfc8054",
  null
  
)

export default component.exports